// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "RoutingVocabularyDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { RoutingVocabularyCategoryDtoGenShape } from "./routing-vocabulary-category-dto.gen";
import { RoutingResidentTenureMappingDtoGenShape } from "./routing-resident-tenure-mapping-dto.gen";

export const RoutingVocabularyDtoGenShape = z.strictObject({
  categories: z.array(RoutingVocabularyCategoryDtoGenShape),
  tenureMapping: z.array(RoutingResidentTenureMappingDtoGenShape),
});
